import { useHazardsStore, useMapStore, MapboxSource } from '@/features';

export const initialiseHazardSources = () => {
  const hazardsStore = useHazardsStore();
  const mapStore = useMapStore();

  const hazardMarkerGeoSource = hazardsStore.getHazardPointGeoSource;
  const hazardPolygonsGeoSource = hazardsStore.getHazardPolygonsGeoSource;
  const hazardFireShapePolygonsGeoSource = hazardsStore.getHazardFireShapePolygonsGeoSource;

  const fireDangerRatingsPolygonsGeoSource = hazardsStore.getFireDangerRatingsPolygonsGeoSource;

  mapStore.addOrSetSources({
    [MapboxSource.hazardsMarkersSource]: {
      type: 'geojson',
      data: hazardMarkerGeoSource,
    },
    [MapboxSource.hazardsPolygonsSource]: {
      type: 'geojson',
      data: hazardPolygonsGeoSource,
    },
    [MapboxSource.hazardsFireShapePolygonsSource]: {
      type: 'geojson',
      data: hazardFireShapePolygonsGeoSource,
    },
    [MapboxSource.fireDangerRatingsPolygonsSource]: {
      type: 'geojson',
      data: fireDangerRatingsPolygonsGeoSource,
    },
  });
};
